import { render, staticRenderFns } from "./DilationUpgradeButton.vue?vue&type=template&id=1641f47b&scoped=true&"
import script from "./DilationUpgradeButton.vue?vue&type=script&lang=js&"
export * from "./DilationUpgradeButton.vue?vue&type=script&lang=js&"
import style0 from "./DilationUpgradeButton.vue?vue&type=style&index=0&id=1641f47b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1641f47b",
  null
  
)

export default component.exports